module.exports = __webpack_public_path__ + "static/media/dataAnalysis.e7ba5d80.svg";